export default {
  "de-DE": {
    "text001": "Ergebnisse",
    "text002": "Diese erst- und zweitplatzierten Helden werden zukünftig mit \"Wähle deine Legenden\"-Outfits im Spiel erscheinen!<br><br>Männliche Helden<br>1. Platz: {{no1_man_name}}<br>2. Platz: {{no2_man_name}}<br><br>Weibliche Helden<br>1. Platz: {{no1_woman_name}}<br>2. Platz: {{no2_woman_name}}",
    "text003": "Besondere Outfits:",
    "text004": "Helden",
    "text005": "Heldinnen",
    "text006": "Wähle deine Legenden: Runde 4 - Die Ergebnisse",
    "text007": "1-200",
    "text008": "201-400",
    "text009": "401-600",
    "text010": "Ab 601",
    "text011": "{{votes}}",
    "text012": "Rang",
    "text013": "Stimmen",
    "text014": "Name",
    "text015": "Titel"
  },
  "en-GB": {
    "text001": "Results",
    "text002": "These top-place finishers will appear in-game in the future wearing special Choose Your Legends edition outfits!<br><br>Men's Division<br>1st place: {{no1_man_name}}<br>2nd place: {{no2_man_name}}<br><br>Women's Division<br>1st place: {{no1_woman_name}}<br>2nd place: {{no2_woman_name}}",
    "text003": "Special Outfits:",
    "text004": "Heroes",
    "text005": "Heroines",
    "text006": "Choose Your Legends: Round 4 - The Results",
    "text007": "1st - 200th",
    "text008": "201st - 400th",
    "text009": "401st - 600th",
    "text010": "601st onward",
    "text011": "{{votes}}",
    "text012": "Rank",
    "text013": "Votes",
    "text014": "Name",
    "text015": "Title"
  },
  "es-ES": {
    "text001": "Resultados",
    "text002": "¡Los personajes que acabaron en las posiciones más altas se añadirán al juego con atuendos especiales de Elige a tus héroes!<br><br>Personajes masculinos<br>1.er puesto: {{no1_man_name}}<br>2.º puesto: {{no2_man_name}}<br><br>Personajes femeninos<br>1.er puesto: {{no1_woman_name}}<br>2.º puesto: {{no2_woman_name}}",
    "text003": "Atuendos especiales:",
    "text004": "Héroes",
    "text005": "Heroínas",
    "text006": "Elige a tus héroes (4) - Resultados",
    "text007": "1-200",
    "text008": "201-400",
    "text009": "401-600",
    "text010": "601 o más",
    "text011": "{{votes}}",
    "text012": "Puesto",
    "text013": "Votos",
    "text014": "Nombre",
    "text015": "Título"
  },
  "fr-FR": {
    "text001": "Résultats",
    "text002": "Des versions spéciales « Choisissez vos héros » des personnages désignés seront ajoutées au jeu !<br><br>Héros<br>1re place : {{no1_man_name}}<br>2e place : {{no2_man_name}}<br><br>Héroïnes<br>1re place : {{no1_woman_name}}<br>2e place : {{no2_woman_name}}",
    "text003": "Tenues spéciales :",
    "text004": "Héros",
    "text005": "Héroïnes",
    "text006": "Choisissez vos héros n° 4 - Les résultats",
    "text007": "1 - 200",
    "text008": "201 - 400",
    "text009": "401 - 600",
    "text010": "601 et plus",
    "text011": "{{votes}}",
    "text012": "Rang",
    "text013": "Votes",
    "text014": "Nom",
    "text015": "Titre"
  },
  "it-IT": {
    "text001": "Risultati",
    "text002": "Questi personaggi che hanno raggiunto i primi posti appariranno in Fire Emblem Heroes con un completo speciale Scegli le tue leggende!<br><br>Uomini<br>1º: {{no1_man_name}}<br>2º: {{no2_man_name}}<br><br>Donne<br>1ª: {{no1_woman_name}}<br>2ª: {{no2_woman_name}}",
    "text003": "Completi speciali - Risultati",
    "text004": "Eroi",
    "text005": "Eroine",
    "text006": "Scegli le tue leggende 4 - Risultati",
    "text007": "1º-200º",
    "text008": "201º-400º",
    "text009": "401º-600º",
    "text010": "601º e oltre",
    "text011": "{{votes}}",
    "text012": "Posizione",
    "text013": "Voti",
    "text014": "Nome",
    "text015": "Titolo"
  },
  "ja-JP": {
    "text001": "結果発表",
    "text002": "男性1位の{{no1_man_name}}、2位の{{no2_man_name}}と<br>女性1位の{{no1_woman_name}}、2位の{{no2_woman_name}}が<br>総選挙特別versionとして登場することが決まりました！",
    "text003": "特別衣装で登場",
    "text004": "男性キャラクター",
    "text005": "女性キャラクター",
    "text006": "第4回英雄総選挙　全結果はこちら",
    "text007": "1位～200位",
    "text008": "201位～400位",
    "text009": "401位～600位",
    "text010": "601位～",
    "text011": "{{votes}}票",
    "text012": "順位",
    "text013": "票数",
    "text014": "名前",
    "text015": "シリーズ名"
  },
  "zh-TW": {
    "text001": "公布結果",
    "text002": "男性角色第1名{{no1_man_name}}、第2名{{no2_man_name}}和<br>女性角色第1名{{no1_woman_name}}、第2名{{no2_woman_name}}<br>將以總選舉特別版的姿態登場！",
    "text003": "以特別服裝登場",
    "text004": "男性角色",
    "text005": "女性角色",
    "text006": "第4回英雄總選舉　所有結果公布於此",
    "text007": "第1名～第200名",
    "text008": "第201名～第400名",
    "text009": "第401名～第600名",
    "text010": "第601名～",
    "text011": "{{votes}}票",
    "text012": "排名",
    "text013": "票數",
    "text014": "角色名",
    "text015": "系列作名稱"
  },
  "en-US": {
    "text001": "Results",
    "text002": "These top-place finishers will appear in-game in the future wearing special Choose Your Legends edition outfits!<br><br>Men's Division<br>1st place: {{no1_man_name}}<br>2nd place: {{no2_man_name}}<br><br>Women's Division<br>1st place: {{no1_woman_name}}<br>2nd place: {{no2_woman_name}}",
    "text003": "Special Outfits:",
    "text004": "Heroes",
    "text005": "Heroines",
    "text006": "Choose Your Legends: Round 4 - The Results",
    "text007": "1st - 200th",
    "text008": "201st - 400th",
    "text009": "401st - 600th",
    "text010": "601st onward",
    "text011": "{{votes}}",
    "text012": "Rank",
    "text013": "Votes",
    "text014": "Name",
    "text015": "Title"
  },
  "es-MX": {
    "text001": "Resultados",
    "text002": "¡Los personajes que acabaron en las posiciones más altas se añadirán al juego con atuendos especiales de Elige a tus leyendas!<br><br>Personajes masculinos<br>1.er puesto: {{no1_man_name}}<br>2.do puesto: {{no2_man_name}}<br><br>Personajes femeninos<br>1.er puesto: {{no1_woman_name}}<br>2.do puesto: {{no2_woman_name}}",
    "text003": "Atuendos especiales:",
    "text004": "Héroes",
    "text005": "Heroínas",
    "text006": "Elige a tus leyendas (4) - Resultados",
    "text007": "1-200",
    "text008": "201-400",
    "text009": "401-600",
    "text010": "601 o más",
    "text011": "{{votes}}",
    "text012": "Puesto",
    "text013": "Votos",
    "text014": "Nombre",
    "text015": "Título"
  },
  "fr-CA": {
    "text001": "Résultats",
    "text002": "Des versions spéciales « Choisissez vos héros » des personnages désignés seront ajoutées au jeu!<br><br>Héros<br>1re place : {{no1_man_name}}<br>2e place : {{no2_man_name}}<br><br>Héroïnes<br>1re place : {{no1_woman_name}}<br>2e place : {{no2_woman_name}}",
    "text003": "Tenues spéciales :",
    "text004": "Héros",
    "text005": "Héroïnes",
    "text006": "Choisissez vos héros n° 4 - Les résultats",
    "text007": "1 - 200",
    "text008": "201 - 400",
    "text009": "401 - 600",
    "text010": "601 et plus",
    "text011": "{{votes}}",
    "text012": "Rang",
    "text013": "Votes",
    "text014": "Nom",
    "text015": "Titre"
  },
  "pt-BR": {
    "text001": "Resultados",
    "text002": "Os seguintes personagens foram os mais votados e aparecerão no jogo usando vestimentas especiais de \"Escolha suas lendas\"!<br><br>Personagens masculinos<br>1º lugar: {{no1_man_name}}<br>2º lugar: {{no2_man_name}}<br><br>Personagens femininos<br>1º lugar: {{no1_woman_name}}<br>2º lugar: {{no2_woman_name}}",
    "text003": "Vestimentas especiais:",
    "text004": "Heróis",
    "text005": "Heroínas",
    "text006": "Escolha suas lendas (4) - Resultados",
    "text007": "1º - 200º",
    "text008": "201º - 400º",
    "text009": "401º - 600º",
    "text010": "601º ou mais",
    "text011": "{{votes}}",
    "text012": "Classificação",
    "text013": "Votos",
    "text014": "Nome",
    "text015": "Título"
  }
}